export default {
	impressions: '/campaigns/impressions-per-budget',
	budgetRange: '/campaigns/budget-range',
	campaigns: '/campaigns',
	campaign: (id: number) => `/campaigns/${id}`,
	denyCampaign: (id: number) => `/campaigns/${id}/deny`,
	campaignStatus: (id: number) => `/campaigns/${id}/status`,
};
